import * as React from 'react';
import * as Colors from './Colors'
import * as Styles from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';

const styles = () => Styles.createStyles({
    table: {
        margin: "0px"
    },
    row: {
        border: "solid",
        borderWidth: "1px",
        borderColor: Colors.white,
    },
    leftCell: {
        textAlign: "center",
        width: "15%",
        padding: "3px", 
        fontSize: "0.95rem",
        backgroundColor: Colors.secondaryColor,
        color: Colors.textColor,
        minWidth: "100px"
    },
    leftCellInner: {
        padding: "0px",
        height: "100%",
        verticalAlign: "bottom"
    },
    leftCellInnerText: {
    },
    rightCell: {
        color: Colors.inputColor,
        //margin: "10px",
        fontSize: "0.95rem",
        paddingLeft: "1px",
        //paddingTop: "15px",
        //paddingBottom: "15px"
    },
})

interface Props extends Styles.WithStyles<typeof styles> {
    elm: any
    shouldUpdate: any
}

interface LocalState {
    isHelpContentModalOpen: boolean
}


class Col2TableRow extends React.Component<Props, LocalState> {
    displayName = "Col2TableRow"
    constructor(props) {
        super(props)
        this.state = {
            isHelpContentModalOpen: false
        }
    }

    shouldComponentUpdate(np, ns) {
        return np.shouldUpdate[np.elm.name]
    }

    public render() {
        const { classes } = this.props;
        return <TableRow key={`row_${this.props.elm.name}`} className={classes.row}>
            {
                this.props.elm.name != "" ?
                    <TableCell className={classes.leftCell} component="th" scope="row">
                        <div className={classes.leftCellInner}>
                            <div className={classes.leftCellInnerText}>
                                {this.props.elm.name}
                                {
                                    this.props.elm.helpContent && (
                                        <IconButton
                                            edge="end"
                                            color="inherit"
                                            size="small"
                                            onClick={() => this.setState({ isHelpContentModalOpen: true })}
                                        >
                                            <Icons.HelpOutline />
                                        </IconButton>
                                    )
                                }
                            </div>
                        </div>
                    </TableCell>
                    : null
            }
            <TableCell className={classes.rightCell} align="left">
                {this.props.elm.content()}
            </TableCell>
            <Modal
                open={this.state.isHelpContentModalOpen}
                onClose={() => this.setState({ isHelpContentModalOpen: false })}
            >
                <div
                    style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        minWidth: '350px',
                        width: 'auto',
                        height: 'auto',
                        backgroundColor: "white",
                        borderRadius: "10px",
                        padding: '35px 15px 15px',
                    }}
                >
                    <IconButton
                        edge="end"
                        color="inherit"
                        size="small"
                        onClick={() => this.setState({ isHelpContentModalOpen: false })}
                        style={{position: "absolute", top: 10, right: 10 }}
                    >
                        <Icons.Close />
                    </IconButton>
                    {this.props.elm.helpContent}
                </div>
            </Modal>
        </TableRow>
    }
}

export default Styles.withStyles(styles)(Col2TableRow)
